import { GridColDef } from "@mui/x-data-grid";
import CustomDataGrid from "../../../components/ui/customDataGrid/customDataGrid.component";
import { useTranslation } from "react-i18next";
import { Print } from "@mui/icons-material";
import { EQUIPMENTS_ENDPOINT } from "../../../consts";
import { useNavigate } from "react-router-dom";
import GridAddressCell from "../../../components/ui/gridAddressCell/gridAddressCell.component";

export default function EquipmentList() {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const columns: GridColDef[] = [
    {
      field: "id",
      headerName: "ID",
    },
    {
      field: "name",
      headerName: t("Equipment"),
      valueGetter: (value, row) => row.full_name,
    },
    {
      field: "client_name",
      headerName: t("Client Name"),
      sortable: false,
      valueGetter: (value, row) => row.client_name || "",
    },
    {
      field: "ownership",
      headerName: t("Ownership"),
      editable: false,
      valueGetter: (value, row) => row.ownership_display,
    },
    {
      field: "kind",
      headerName: t("Kind"),
      editable: false,
      valueGetter: (value, row) => row.kind_display,
    },
    {
      field: "is_installed",
      headerName: t("Is installed"),
      type: "boolean",
    },
    {
      field: "installation_address",
      headerName: t("Installation address"),
      sortable: false,
      renderCell: (params) => {
        return <GridAddressCell address={params.row.installation_address} />;
      },
      valueGetter: (value, row) => {
        const address = row.installation_address;
        if (
          address &&
          address.street &&
          address.city &&
          address.zip_code &&
          address.country
        ) {
          return `${address.street}, ${address.city}, ${address.zip_code}, ${address.country}`;
        }
        return "";
      },
    },
  ];

  const handleRowClick = (id: string) => {
    navigate(`/equipment-section/equipments/${id}`);
  };

  return (
    <CustomDataGrid
      icon={<Print />}
      title={t("Equipment")}
      url={EQUIPMENTS_ENDPOINT}
      gridSettingsKey="EQUIPMENTS"
      columns={columns}
      refreshEventName="equipmentAdded"
      onRowClick={handleRowClick}
    />
  );
}
